import React, { useEffect, useState } from "react";

import { Button, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";

import useStyles from "../Lobby.styles";
import {
  addRemoveFavoritesStart,
  resetSuccess
} from "../../../../redux-saga/redux/casino/lobby/favorites";

const FavoriteButton = ({
  isFavorite = null,
  favBtnClass = null,
  gameId,
  recallFav = null
}) => {
  const { favStatus } = useSelector((state) => state.favorites);
  const { metamaskLoggedIn, isLoggedIn } = useSelector(
    (state) => state.authentication
  );
  const [FavBtnActive, setFavBtnActive] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();

  const addRemoveFavorite = () => {
    if (!(metamaskLoggedIn || isLoggedIn)) {
      toast.error(t("GAME.GAME_LOGIN_MSG"), {
        id: "GAME_LOGIN_MSG"
      });
      return;
    }
    dispatch(
      addRemoveFavoritesStart({
        gameId: parseInt(gameId),
        favStatus: FavBtnActive,
        recallFav
      })
    );
  };

  useEffect(() => {
    if (favStatus?.gameId === parseInt(gameId)) {
      setFavBtnActive((current) => !current);
      dispatch(resetSuccess());
    }
  }, [favStatus, dispatch, gameId]);

  useEffect(() => {
    if (isFavorite) {
      setFavBtnActive(true);
    } else {
      setFavBtnActive(false);
    }
  }, [isFavorite]);

  return (
    <>
      {isMobile ? (
        <Grid className={classes.modalFavBtn}>
          <Button onClick={addRemoveFavorite}>
            {FavBtnActive ? (
              <>
                <FavoriteIcon className={classes?.fill} />
              </>
            ) : (
              <>
                <FavoriteBorderIcon className={classes?.notfill} />
              </>
            )}
          </Button>
        </Grid>
      ) : (
        <Button className={favBtnClass} onClick={addRemoveFavorite}>
          {FavBtnActive ? (
            <FavoriteIcon className={classes?.fill} />
          ) : (
            <FavoriteBorderIcon className={classes?.notfill} />
          )}
        </Button>
      )}
    </>
  );
};

export default FavoriteButton;
